import React from 'react';
import dayjs from 'src/utils/dayjs';
import { PlanSection } from './PlanSection';
import LinearProgress from '@material-ui/core/LinearProgress';
import { ProcessedPlanData } from './PlanQueue.types';
import { MinimalItem } from 'src/pages/AssortmentBuild/Planning.types';
import styles from './PlanQueue.styles';
import { PlanQueueError } from './PlanQueueError';
import { PlanErrorKey } from './PlanQueue.types';

interface AssortmentPlanTabProps {
  hasError: boolean;
  /** The data count, passed in to not 'reprocess' the data for counting */
  count: number;
  data: ProcessedPlanData;
  search: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function PlanTime(item: MinimalItem | undefined) {
  return <span>{dayjs(`${item?.updatedAt}`).format('h:mm a')}</span>;
}

export const AssortmentPlanTab = ({ hasError, data, search, onSearchChange }: AssortmentPlanTabProps) => {
  const { pending, processing, completed, failed } = data;
  return hasError ? (
    <PlanQueueError planKey={PlanErrorKey.Assortment} />
  ) : (
    <div>
      <div className={styles.searchContainer}>
        <input type="text" placeholder="Search item by description" value={search} onChange={onSearchChange} />
      </div>
      <section className={styles.itemsContainer}>
        <PlanSection
          items={pending.items}
          sectionName={'Pending'}
          secondaryList={() => <LinearProgress variant={'indeterminate'} />}
          componentType={{ component: 'div' }}
          badgeColor={pending.badgeColor}
        />
        <PlanSection
          items={processing.items}
          sectionName={'Processing'}
          secondaryList={() => <LinearProgress variant={'buffer'} value={0} valueBuffer={0} />}
          componentType={{ variant: 'caption' }}
          badgeColor={processing.badgeColor}
        />
        <PlanSection
          items={completed.items}
          sectionName={'Completed'}
          secondaryList={PlanTime}
          componentType={{ variant: 'caption' }}
          badgeColor={completed.badgeColor}
        />
        <PlanSection
          items={failed.items}
          sectionName={'Failed'}
          secondaryList={PlanTime}
          componentType={{ variant: 'caption' }}
          badgeColor={failed.badgeColor}
        />
      </section>
    </div>
  );
};
